import { jsx } from "react/jsx-runtime";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import { validateTidalLicense } from "../../base/index.js";
function ShoppingCart(props) {
  return /* @__PURE__ */ jsx(
    ShoppingCartIcon,
    {
      "data-testid": "ShoppingCart",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "ShoppingCart",
      "data-tidal-icon-meta": "money,invoices,payments"
    }
  );
}
ShoppingCart.tidalIconMeta = {
  categories: "money,invoices,payments",
  name: "ShoppingCart"
};
validateTidalLicense();
export {
  ShoppingCart
};
//# sourceMappingURL=ShoppingCart.js.map
